import React, {FC} from 'react';
import Helmet from 'react-helmet';
import {
  ShowToastType,
  ToastContextProvider,
} from '../../Toast/ToastContextProvider';
import HelpdeskContactPageUI from '../../ui/Helpdesk/ContactPage/ContactPageUI';
import {ClientSideNavigationProvider} from '../../ui/Navigation/ClientSideLink/ClientSideLink';
import {filterHiddenSections} from './hiddenSections';
import useFilterVipSections from './hooks/useFilterVipSectionts';
import {HelpCenterContactPageData, HelpCenterPageProps} from './types';

type Props = HelpCenterPageProps<HelpCenterContactPageData>;

const HelpCenterContactPage: FC<
  Omit<Props, 'alternateLink'> & {
    showToast: ShowToastType;
  }
> = props => {
  const sections = useFilterVipSections(
    props.isVip,
    props.isCoinsActive,
    props.sections,
  ).filter(filterHiddenSections);

  return (
    <ToastContextProvider showToast={props.showToast}>
      <Helmet
        title={props.translations.contactPage.seo_page_title}
        meta={[
          {
            name: 'description',
            content: props.translations.contactPage.seo_page_description,
          },
          {name: 'robots', content: 'index, follow'},
        ]}
        link={[{rel: 'canonical', href: props.canonicalUrl}]}
      ></Helmet>
      <ClientSideNavigationProvider navigateClient={props.navigateClient}>
        <HelpdeskContactPageUI
          locale={props.locale}
          isProduction={props.isProduction}
          localizedServiceEmailAddress={props.localizedServiceEmailAddress}
          sendContactForm={props.sendContactForm}
          sections={sections}
          translations={props.translations}
          endpoints={props.endpoints}
          isVip={props.isVip}
          isShowOldHelpCenterEnabled={props.isShowOldHelpCenterEnabled}
          CloudflareTurnstile={props.CloudflareTurnstile}
        />
      </ClientSideNavigationProvider>
    </ToastContextProvider>
  );
};

export default HelpCenterContactPage;
